//请自行添加语言资源
const distributeView = {
  msg:{
  }
};
export default distributeView



// WEBPACK FOOTER //
// ./src/page/report/distributeView/lang/distributeView.zh.js